import { createSvgIcon } from "@mui/material";

const FundAccountingProductIcon = createSvgIcon(
  <svg viewBox="0 0 20 20" fill="none">
    <path
      d="M13.6574 4.16675H7.4959C6.59374 4.16675 6.15284 5.26718 6.80542 5.8901L10.7322 9.6384C10.9386 9.83537 10.9386 10.1648 10.7322 10.3618L6.80542 14.1101C6.15284 14.733 6.59374 15.8334 7.4959 15.8334H14.1667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>,
  "FundAccountingProductIcon"
);

export default FundAccountingProductIcon;
